module.exports = __webpack_public_path__ + "static/img/RE11.061be30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE11.jpg
// module id = vsJs
// module chunks = 0